import React, { useState } from 'react';
import { Form, Control, Errors } from 'react-redux-form';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../global/img/logo_full_white.png';
import EmailVerificationModal from '../EmailVerificationModal';
import InputFields from '../InputFields';
import { X_AUTH_COMPLETE } from '../../store/constants';
import { resolvePostAuthReturnUrl } from '../../utils/authRedirect';
import { appendReturnUrl, clearXCompletionState, loadXCompletionState } from '../../utils/xAuth';
import '../Signup/style.css';

const sportOptions = ['NFL', 'NBA', 'La Liga', 'EPL', 'IPL'];

function XAuthComplete() {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user);
	const userActions = useSelector((state) => state.userActions);
	const [pendingState] = useState(() => loadXCompletionState());
	const queryReturnUrl = resolvePostAuthReturnUrl(null, window.location.search);
	const returnUrl = pendingState?.returnUrl || queryReturnUrl;
	const isEmailVerified = Boolean(user?.emailVerified || Number(user?.email_verified));
	const isVerificationMode = new URLSearchParams(window.location.search).get('verification') === '1';
	const authErrorMessage = userActions?.xAuthError ? userActions?.message?.message || userActions?.message : '';

	if (user?.login && isVerificationMode && !isEmailVerified) {
		return (
			<EmailVerificationModal
				show={true}
				onClose={() => null}
				userEmail={user?.email || pendingState?.prefill?.email}
				returnUrl={returnUrl}
			/>
		);
	}

	if (!pendingState?.completion_token) {
		return (
			<section className='signupMainSection'>
				<div className='signupMainDiv'>
					<img src={Logo} alt='Inside Injuries Logo' className='signupLogo' />
					<p className='signupHeaderText'>Complete X Sign-In</p>
					<div className='signupFormDiv' style={{ textAlign: 'center' }}>
						<p className='loginFlowText' style={{ display: 'block', marginBottom: 24 }}>
							Your X sign-in session is missing or expired. Please start again.
						</p>
						<a href={appendReturnUrl('/login', returnUrl)} className='loginButton' style={{ display: 'inline-flex', justifyContent: 'center', textDecoration: 'none' }}>
							Back to Login
						</a>
					</div>
				</div>
			</section>
		);
	}

	const preferredName =
		pendingState?.prefill?.name ||
		pendingState?.prefill?.display_name ||
		pendingState?.prefill?.username ||
		pendingState?.prefill?.screen_name;
	const preferredHandle = pendingState?.prefill?.username || pendingState?.prefill?.screen_name;
	const initialEmail = pendingState?.prefill?.email || '';
	const initialSport = pendingState?.prefill?.favorite_sport || 'NFL';

	const handleSubmit = (formData) => {
		dispatch({
			type: X_AUTH_COMPLETE,
			payload: {
				completionToken: pendingState?.completion_token,
				email: formData?.email,
				favoriteSport: formData?.favorite_sport,
				returnUrl
			}
		});
	};

	const handleStartOver = () => {
		clearXCompletionState();
		window.location.href = appendReturnUrl('/login', returnUrl);
	};

	return (
		<section className='signupMainSection'>
			<div className='signupMainDiv'>
				<img src={Logo} alt='Inside Injuries Logo' className='signupLogo' />
				<p className='signupHeaderText'>Finish Setting Up Your Account</p>
				<div className='signupFormDiv'>
					{preferredName ? (
						<div
							style={{
								background: '#eef3ff',
								borderRadius: 14,
								padding: '14px 16px',
								marginBottom: 18,
								color: '#0f1c3f'
							}}
						>
							<strong style={{ display: 'block', marginBottom: 4 }}>{preferredName}</strong>
							{preferredHandle ? <span>@{preferredHandle}</span> : null}
						</div>
					) : null}
					<p className='loginFlowText' style={{ display: 'block', marginBottom: 18 }}>
						Add your email and favorite sport to finish creating your Inside Injuries account.
					</p>
					{authErrorMessage ? <p className='formInputError'>{authErrorMessage}</p> : null}
					<Form key={`${pendingState?.completion_token}-${initialEmail}-${initialSport}`} model='userActions.xComplete' onSubmit={handleSubmit} initialState={{ email: initialEmail, favorite_sport: initialSport }}>
						<div className='inputCol'>
							<InputFields model='.email' inputType='text' type='email' placeholder='Enter your email' label='Email' />
						</div>
						<div className='inputCol'>
							<label className='inputLabel' style={{ display: 'block', marginBottom: 8 }}>
								Choose your favorite
							</label>
							<div className='radioGroup'>
								{sportOptions.map((sport) => (
									<label key={sport} style={{ marginRight: 16 }}>
										<Control.radio model='.favorite_sport' value={sport} validators={{ required: (value) => !!value }} /> {sport}
									</label>
								))}
							</div>
							<Errors className='formInputError' model='.favorite_sport' messages={{ required: 'Required*' }} show={{ touched: true, focus: false }} />
						</div>
						<div className='w-100'>
							<Control.button model='userActions.xComplete' className='loginButton' type='submit' disabled={userActions?.isLoading}>
								{userActions?.isLoading ? 'Saving...' : 'Complete Sign-In'}
							</Control.button>
						</div>
					</Form>
					<p className='loginFlowText' style={{ marginTop: 16 }}>
						Want to use a different X account?
						<button
							type='button'
							onClick={handleStartOver}
							className='btn btn-link loginFlowLink'
							style={{ paddingTop: 0, paddingBottom: 0, marginLeft: 6 }}
						>
							Start over
						</button>
					</p>
				</div>
			</div>
		</section>
	);
}

export default XAuthComplete;
